module.exports = __webpack_public_path__ + "img/app1.81aa3a08.png";